/**
 * Re 1 Previous Drops — Swiper with merchant-defined breakpoints.
 */
(function () {
  function readNumber(value, fallback) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function readBool(value) {
    return value === 'true' || value === true;
  }

  function getSlidesPerView(swiper) {
    if (!swiper) return 3;
    if (typeof swiper.params.slidesPerView === 'number') {
      return swiper.params.slidesPerView;
    }
    return 3;
  }

  function toggleNav(swiper, prevEl, nextEl, slideCount, container) {
    const mobile = readNumber(container.dataset.slidesMobile, 3);
    const tablet = readNumber(container.dataset.slidesTablet, 4);
    const desktop = readNumber(container.dataset.slidesDesktop, 5);
    const bpTablet = readNumber(container.dataset.breakpointTablet, 750);
    const bpDesktop = readNumber(container.dataset.breakpointDesktop, 990);

    const width = window.innerWidth;
    let perView = mobile;
    if (width >= bpDesktop) perView = desktop;
    else if (width >= bpTablet) perView = tablet;

    const hide = slideCount <= perView;

    [prevEl, nextEl].forEach((button) => {
      if (!button) return;
      button.style.visibility = hide ? 'hidden' : 'visible';
      button.disabled = hide;
    });

    if (swiper) {
      swiper.allowTouchMove = !hide;
    }
  }

  function buildBreakpoints(container) {
    const mobile = readNumber(container.dataset.slidesMobile, 3);
    const tablet = readNumber(container.dataset.slidesTablet, 4);
    const desktop = readNumber(container.dataset.slidesDesktop, 5);
    const spaceMobile = readNumber(container.dataset.spaceMobile, 10);
    const spaceTablet = readNumber(container.dataset.spaceTablet, 12);
    const spaceDesktop = readNumber(container.dataset.spaceDesktop, 14);
    const bpTablet = readNumber(container.dataset.breakpointTablet, 750);
    const bpDesktop = readNumber(container.dataset.breakpointDesktop, 990);

    const breakpoints = {};

    breakpoints[bpTablet] = {
      slidesPerView: tablet,
      spaceBetween: spaceTablet,
    };

    breakpoints[bpDesktop] = {
      slidesPerView: desktop,
      spaceBetween: spaceDesktop,
    };

    return {
      slidesPerView: mobile,
      spaceBetween: spaceMobile,
      breakpoints,
    };
  }

  function initDropsSwiper(container) {
    if (container.dataset.dropsInitialized === 'true') return;
    if (typeof window.Swiper === 'undefined') return;

    container.dataset.dropsInitialized = 'true';

    const sectionId = container.getAttribute('data-drops-swiper');
    const carousel = container.closest('.re-1-drops__carousel');
    const prevEl =
      carousel?.querySelector(`[data-drops-prev="${sectionId}"]`) ||
      document.querySelector(`[data-drops-prev="${sectionId}"]`);
    const nextEl =
      carousel?.querySelector(`[data-drops-next="${sectionId}"]`) ||
      document.querySelector(`[data-drops-next="${sectionId}"]`);

    const slideCount = container.querySelectorAll('.swiper-slide').length;
    const { slidesPerView, spaceBetween, breakpoints } = buildBreakpoints(container);
    const enableLoop = readBool(container.dataset.enableLoop);

    const swiper = new window.Swiper(container, {
      slidesPerView,
      slidesPerGroup: 1,
      spaceBetween,
      speed: 400,
      loop: enableLoop && slideCount > slidesPerView,
      watchOverflow: true,
      grabCursor: true,
      breakpoints,
      navigation: {
        prevEl,
        nextEl,
        disabledClass: 'swiper-button-disabled',
      },
      on: {
        init(instance) {
          toggleNav(instance, prevEl, nextEl, slideCount, container);
        },
        resize(instance) {
          toggleNav(instance, prevEl, nextEl, slideCount, container);
        },
        breakpoint(instance) {
          toggleNav(instance, prevEl, nextEl, slideCount, container);
        },
      },
    });

    return swiper;
  }

  function boot() {
    if (typeof window.Swiper === 'undefined') {
      window.setTimeout(boot, 100);
      return;
    }

    document.querySelectorAll('[data-drops-swiper]').forEach(initDropsSwiper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
